/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAgentSkillPathParams = NonNullable<operations['postAgentSkill']['parameters']['path']>;

export type PostAgentSkillRequestBody = OperationRequestBodyContent<operations['postAgentSkill']>;

export interface Input extends PostAgentSkillPathParams {
  apiVersion?: string;
  body: PostAgentSkillRequestBody;
}

export async function postAgentSkill(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/skills', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
